import { makeStyles } from "@material-ui/core";

export const useStyle = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "0 12px 16px",
  },
  header: {
    alignItems: "center",
    textAlign: "center",
    padding: "16px 8px",
    backgroundColor: "transparent",
    borderRadius: 12,
  },
  headerpickup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 52,
    backgroundColor: "#e3f2fd",
    border: "none",
    borderRadius: 8,
    padding: "8px 4px",
  },
  headerpickupWrong: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 52,
    backgroundColor: "#fff3e0",
    border: "none",
    borderRadius: 8,
    padding: "8px 4px",
  },
  headerdelivery: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 52,
    backgroundColor: "#e8f5e9",
    border: "none",
    borderRadius: 8,
    padding: "8px 4px",
  },
  headerMaterial: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    minHeight: 48,
    border: "none",
    borderRadius: 8,
  },
  text: {
    backgroundColor: "white",
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    alignItems: "center",
    textAlign: "center",
    width: "80%",
    margin: "0 auto",
    padding: "8px 4px",
    fontSize: "0.875rem",
  },
  textButton: {
    backgroundColor: "#ffccbc",
    border: "none",
    borderRadius: 8,
    alignItems: "center",
    textAlign: "center",
    margin: "0 4px",
    padding: "12px 4px",
    color: "#d32f2f",
    fontWeight: 600,
    fontSize: "0.875rem",
    minHeight: 48,
    cursor: "pointer",
  },
  viewTicket: {
    backgroundColor: "#c5e1a5",
    border: "none",
    borderRadius: 8,
    alignItems: "center",
    textAlign: "center",
    margin: "0 4px",
    padding: "12px 4px",
    color: "#33691e",
    fontWeight: 600,
    fontSize: "0.875rem",
    minHeight: 48,
    cursor: "pointer",
  },
}));
